import { useState } from "react";
import ReactQuill from "react-quill-new";
import { Card, CardBody, Col, Row } from "reactstrap";
import { BubbleThemeTitle } from "../../../../Constants/Constants";
import { BubbleThemeContent } from "../../../../Data/Miscellaneous/Editor";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BubbleTheme = () => {
  const [value, setValue] = useState(BubbleThemeContent);
  return (
    <Row>
      <Col sm="12">
        <Card>
          <CommonCardHeader title={BubbleThemeTitle} />
          <CardBody>
            <ReactQuill className="toolbar-box" theme="bubble" value={value} onChange={setValue} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default BubbleTheme;
